import * as React from 'react';
import Switch from '@mui/joy/Switch';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

interface SwitchProp{
  leftLabel:string,
  rightLabel:string,
  checked:boolean,
  setChecked:any,
  disable:boolean
}

const SwitchComponent:React.FC<SwitchProp>=({leftLabel,rightLabel,checked,setChecked,disable})=> {
  return (
    <Stack direction="row" spacing={2}>
      <Switch
      disabled={disable}
      checked={checked}
      onChange={(event) => setChecked(event.target.checked)}
        slotProps={{
          track: {
            children: (
              <React.Fragment>
                <Typography component="span" level="inherit" sx={{ ml: '10px' }}>
                  {leftLabel}
                </Typography>
                <Typography component="span" level="inherit" sx={{ mr: '10px' }}>
                  {rightLabel}
                </Typography>
              </React.Fragment>
            ),
          },
        }}
        sx={{
          '--Switch-thumbSize': '27px',
          '--Switch-trackWidth': '64px',
          '--Switch-trackHeight': '31px',
        }}
      />
      {/* <Switch
        color="success"
        slotProps={{
          track: {
            children: (
              <React.Fragment>
                <span>I</span>
                <span>0</span>
              </React.Fragment>
            ),
            sx: {
              justifyContent: 'space-around',
            },
          },
        }}
        sx={{
          '--Switch-thumbSize': '27px',
          '--Switch-trackWidth': '52px',
          '--Switch-trackHeight': '31px',
        }}
      /> */}
    </Stack>
  );
}

export default SwitchComponent;